import Vue, { PropType } from 'vue';
import IconBase from '../icon';
import { IconProps, SVGJson } from '../utils/types';
import useSizeProps from '../utils/use-size-props';

const element: SVGJson = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"logo-twitter"},"children":[{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M22.582 4.80078C22.0586 5.22266 21.1055 5.67969 20.4999 5.81771C19.6895 4.14975 17.979 3 16 3C13.2386 3 11 5.23858 11 8L11 8.99997C7.27005 8.99997 3.93758 7.29821 1.73663 4.62874C1.26128 5.82662 1 7.13272 1 8.49986C1 12.9338 3.74829 16.7258 7.63432 18.2654C6.21468 19.2539 4.58031 19.9554 2.81523 20.286C4.62138 21.3743 6.73756 22.0004 8.99999 22.0004C15.6274 22.0004 21 16.6274 21 10V8.83057C21.707 7.96875 22.1546 7.36842 22.6037 6.71189","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const LogoTwitter = Vue.extend<IconProps>({
  name: 'LogoTwitterIcon',
  functional: true,
  props: {
    size: {
      type: String,
    },
    onClick: {
      type: Function as PropType<IconProps['onClick']>,
    },
    fillColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeWidth: {
      type: Number,
      default: 2
    }
  },
  render(createElement, context) {
    const { props, data } = context;
    const { size, ...otherProps } = props;

    const { className, style } = useSizeProps(size);
    const fullProps = {
      ...otherProps || {},
      id: 'logo-twitter',
      icon: element,
      staticClass: className,
      style,
    };
    data.props = fullProps;
    return createElement(IconBase, data);
  },
});

export default LogoTwitter;
